import { render, staticRenderFns } from "./CustomBusinessForm.vue?vue&type=template&id=6fd6c894&scoped=true"
import script from "./CustomBusinessForm.vue?vue&type=script&lang=js"
export * from "./CustomBusinessForm.vue?vue&type=script&lang=js"
import style0 from "./CustomBusinessForm.vue?vue&type=style&index=0&id=6fd6c894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd6c894",
  null
  
)

export default component.exports